import React from "react";
import { Table } from "antd";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";

const AgentTable = ({ tableColumns, dataSource, widget_id, pageSize }) => {
  return (
    <div className="widgetmaker-grid-chart portlet1 p-0 mb-15">
      {tableColumns?.length > 0 ? (
        <Table
          dataSource={dataSource}
          pagination={{
            hideOnSinglePage: dataSource?.length > 10 ? false : true,
            defaultPageSize: pageSize ? pageSize : 10,
            pageSize: pageSize ? pageSize : 10,
            showSizeChanger: false,
            total: dataSource?.length,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          columns={tableColumns}
          //bordered
          className="custom_table_scroll"
          scroll={{
            x: "calc(140rem + 50%)",
            y: dataSource?.length > 10 ? 400 : undefined,
          }}
        />
      ) : (
        <div className="d-flex full_nodata align-items-center">
          <div className="w-100 text-center">
            <div className="Nodata_img mb-15">
              <img src={somethingWentWrong} alt="no data" />
            </div>
            <div className="text_regular-gray">No Data Found</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentTable;
